/**
 * Add-ons (snippets/product-add-ons.liquid).
 *
 * Sends the main product AND every ticked accessory in ONE /cart/add.js
 * request, using the items[] form the endpoint accepts.
 *
 * One request rather than several, for two reasons that both show up as bugs
 * otherwise: the cart drawer would open and re-render once per item, and a
 * failure halfway through a sequence leaves the visitor with some of what they
 * asked for and no clear way to know which.
 *
 * Nothing is added on tick. The selection only travels when the visitor
 * presses Add to cart - ticking a box while still deciding must not put
 * anything in the cart.
 *
 * With no JavaScript the block is hidden by CSS and the form posts normally,
 * so the main product still gets added. A checkbox that silently does nothing
 * is worse than no checkbox.
 */
(function () {
  function setup(root) {
    var formId = root.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    /* Rendered inside a product tab, the block is in a different section
       from the buy buttons and was given that section's id. The page has
       one product form; use it. */
    if (!form) form = document.querySelector('form[id^="ProductForm-"]');
    /* No form to attach to means the buy buttons block was removed. Bail
       rather than leave checkboxes that lead nowhere. */
    if (!form) return;

    function selectedVariantIds() {
      var ids = [];
      root.querySelectorAll('[data-add-on]').forEach(function (box) {
        if (!box.checked || box.disabled) return;
        /* The variant select, when present, is the source of truth - the
           checkbox's own value is only the default variant. */
        var picker = box.closest('.add-ons__item').querySelector('[data-add-on-variant]');
        ids.push(picker ? picker.value : box.value);
      });
      return ids;
    }

    form.addEventListener('submit', function (event) {
      var extras = selectedVariantIds();
      if (extras.length === 0) return;

      /* Without CartAPI there is no AJAX path at all, so the plain POST must
         be allowed to proceed - it adds the main product, which is the more
         important half. */
      if (!window.CartAPI || typeof window.CartAPI.add !== 'function') return;

      /* stopPropagation as well as preventDefault. assets/cart.js listens for
         the same submit at DOCUMENT level and would otherwise ALSO send the
         form - preventDefault only stops the browser's native navigation, not
         other listeners. Without this the cart received two requests: this
         one with the accessories, and cart.js's with the bare product,
         landing a duplicate line.

         stopImmediatePropagation is not needed: the competing listener is on
         a different element, so stopping the bubble is enough. */
      event.preventDefault();
      event.stopPropagation();

      var mainId = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;

      var data = new FormData();
      data.append('items[0][id]', mainId ? mainId.value : '');
      data.append('items[0][quantity]', String(quantity));

      extras.forEach(function (id, i) {
        data.append('items[' + (i + 1) + '][id]', id);
        data.append('items[' + (i + 1) + '][quantity]', '1');
      });

      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;

      window.CartAPI.add(data)
        .then(function () {
          /* Clear the ticks on success. Leaving them ticked invites a second
             press that silently doubles the accessories - the main product
             would be a duplicate line, but the extras would be added again
             without the visitor intending it. */
          root.querySelectorAll('[data-add-on]').forEach(function (box) {
            box.checked = false;
          });
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-add-ons]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
